import { z } from 'zod';
import { statusIdSchema, phoneSchema, emailSchema, MAX_NAME_LENGTH, MAX_ADDRESS_LENGTH, MAX_CITY_LENGTH, MAX_STATE_LENGTH, MAX_COUNTRY_LENGTH, } from './common.js';
/**
 * Schema for creating a new vendor.
 * Mirrors public.vendors user-editable columns. `external_system` and
 * `external_system_record_id` were missing — without them and without
 * `.passthrough()`, the VendorDetail "save external system" button was
 * silently stripping both fields before they reached the DB.
 */
export const vendorCreateSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, 'Vendor name is required')
        .max(MAX_NAME_LENGTH, `Name must be ${MAX_NAME_LENGTH} characters or less`),
    address: z
        .string()
        .max(MAX_ADDRESS_LENGTH, `Address must be ${MAX_ADDRESS_LENGTH} characters or less`)
        .optional()
        .nullable(),
    city: z
        .string()
        .max(MAX_CITY_LENGTH, `City must be ${MAX_CITY_LENGTH} characters or less`)
        .optional()
        .nullable(),
    state: z
        .string()
        .max(MAX_STATE_LENGTH, `State must be ${MAX_STATE_LENGTH} characters or less`)
        .optional()
        .nullable(),
    country: z
        .string()
        .max(MAX_COUNTRY_LENGTH, `Country must be ${MAX_COUNTRY_LENGTH} characters or less`)
        .optional()
        .nullable(),
    phone: phoneSchema,
    email: emailSchema,
    // Status is now managed via status_id foreign key
    status_id: statusIdSchema,
    external_system: z.string().nullable().optional(),
    external_system_record_id: z.string().nullable().optional(),
}).passthrough();
/**
 * Schema for updating an existing vendor.
 * All fields are optional for partial updates.
 */
export const vendorUpdateSchema = vendorCreateSchema.partial();
//# sourceMappingURL=vendorSchema.js.map